export default [
    {
       path: "/ticket",
       name: "Ticket",
       meta: {
         title: "门票",
         keepAlive: true,
         footer: false,
         home: true,
         auth: true, 
         backgroundColor: "#fff"
      },
       component: ()=>import ("@views/ticket/Ticket.vue")
    }, {
       path: "/ticketDetail/:id",
       name: "TicketDetail",
       meta: {
         title: "门票详情",
         keepAlive: true,
         footer: false,
         auth: true, 
         home:false
      },
       component: ()=>import ("@views/ticket/TicketDetail.vue")
    }, {
       path: "/ticketPlaceOrder/:id/:crtip_id",
       name: "TicketPlaceOrder",
       meta: {
         title: "提交订单",
         keepAlive: false,
         footer: false,
         auth: true, 
         home:false
      },
       component: ()=>import ("@views/ticket/TicketPlaceOrder.vue")
    }, {
       path: "/payForTicket/:id",
       name: "PayForTicket",
       meta: {
         title: "门票支付",
         keepAlive: false,
         footer: false,
         auth: true, 
         home:false
      },
       component: ()=>import ("@views/ticket/PayForTicket.vue")
    }, {
       path: "/ticketOrders/:id",
       name: "TicketOrders",
       meta: {
         title: "门票订单",
         keepAlive: false,
         footer: false,
         auth: true,
         home: false
      },
       component: ()=>import ("@views/ticket/TicketOrders.vue")
    }, {
      path: "/ticketOrdersDetail/:id",
      name: "TicketOrdersDetail",
      meta: {
        title: "门票订单详情",
        keepAlive: false,
        footer: false,
        auth: true, 
        home:false
     },
      component: ()=>import ("@views/ticket/TicketOrdersDetail.vue")
    }, {
      path: "/ticketMap",
      name: "TicketMap",
      meta: {
        title: "景点地图",
        keepAlive: false,
        footer: false,
        auth: true,
        home:false
     },
      component: ()=>import ("@views/ticket/TicketMap.vue")
    }, {
      path: "/ticketRefund/:id",
      name: "TicketRefund",
      meta: {
        title: "退票",
        keepAlive: false,
        footer: false,
        auth: true,
        home:false
     },
      component: ()=>import ("@views/ticket/TicketRefund.vue")
    }
   //  {
   //      path: "/new",
   //      name: "New",
   //      meta: {
   //          title: "查看icon",
   //          keepAlive: false,
   //          footer: false,
   //          home:false,
   //          backgroundColor: "#fff"
   //      },
   //     component: ()=>import ("@views/ticket/New.vue")
   //  }
];